import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { Card, CardContent, CardTitle } from './cardStyles'
import { getDocName } from 'hooks/useDocListData'
import DocumentUploaded from 'images/documentUploaded'
import DocumentUploadEdit from 'images/documentUploadEdit'
import { MESSAGES } from '../../messages/messages'

const UploadedCard = ({ id, selectFile = () => {}, onKeyDownHandler = () => {}, ...props }) => {
    const documentName = getDocName(props)
    const uploadRef = useRef(null)
    useEffect(() => {
        uploadRef.current.focus()
    }, [])
    return (
        <Card
            tabIndex={0}
            ref={uploadRef}
            role="label"
            sx={{
                border: (theme) => `1.5px solid ${theme.palette.success.main}`,
                justifyContent: 'center',
                borderRadius: 4,
                padding: 4,
                boxShadow: '0'
            }}
            onClick={selectFile}
            onKeyDown={onKeyDownHandler}
        >
            <Box
                sx={{
                    display: 'grid',
                    justifyItems: 'start'
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        width: '100%',
                        gridAutoFlow: 'column',
                        gap: 1,
                        lineHeight: '0'
                    }}
                >
                    <CardContent
                        sx={{
                            alignItems: 'flex-start'
                        }}
                    >
                        <Box
                            role="img"
                            aria-label="success icon"
                            data-testid="action-success"
                            sx={{
                                color: 'primary.main',
                                p: 0,
                                textAlign: 'right'
                            }}
                        >
                            <DocumentUploaded aria-label="success icon" />
                        </Box>
                        <Box>
                            <CardTitle
                                sx={{
                                    typography: 'mediumBody2',
                                    letterSpacing: 0,
                                    paddingBottom: 1
                                }}
                                data-testid="document-name"
                            >
                                {documentName}
                            </CardTitle>

                            <Typography
                                color="common.charcoal.main"
                                component="span"
                                data-testid="document-status"
                                sx={{
                                    typography: 'regularBody3',
                                    letterSpacing: 0,
                                    backgroundColor: 'common.gray.12',
                                    padding: 1,
                                    borderRadius: 1
                                }}
                            >
                                {MESSAGES.UPLOADED_DESC}
                            </Typography>
                        </Box>
                    </CardContent>
                    <Box
                        role="img"
                        aria-label="edit icon"
                        data-testid="action-edit"
                        sx={{
                            color: 'primary.main',
                            p: 0,
                            textAlign: 'right'
                        }}
                    >
                        <DocumentUploadEdit />
                    </Box>
                </Box>
            </Box>
        </Card>
    )
}

UploadedCard.propTypes = {
    id: PropTypes.number,
    selectFile: PropTypes.func,
    onKeyDownHandler: PropTypes.func
}

export default UploadedCard
